import { Block } from './Block';

export default Block;
export type { BlockProps } from './types';
